const { EventContext } = require('contexts/EventContext');
const { useContext } = require('react');

const useEvent = () => useContext(EventContext);

export default useEvent;
